import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;

//require('foundation-sites');
import './lib/foundation-explicit-pieces';


$(document).foundation();


function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}
function setCookie(name, value, days) {
    var d = new Date;
    d.setTime(d.getTime() + 24*60*60*1000*days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}
function deleteCookie(name) { 
    setCookie(name, '', -1); 
}

$(document).ready(function() {
    
    $( '.selected-post-slider-columns' ).slick({
        centerMode: false,
        centerPadding: '0',
        slidesToShow: 2,
        arrows: true,
        dots: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 782,
                settings: {
                    arrows: false,
                    centerMode: false,
                    centerPadding: '0',
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '0',
                    slidesToShow: 1
                }
            }
        ]
    });
    
    $( '.numbered-slider-columns' ).slick({
        centerMode: true,
        centerPadding: '0',
        slidesToShow: 1,
        arrows: true,
        dots: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 782,
                settings: {
                    arrows: false,
                    centerMode: false,
                    centerPadding: '0',
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '0',
                    slidesToShow: 1
                }
            }
        ]
    });
    
    $( '.video-slider-columns' ).slick({
        centerMode: true,
        centerPadding: '10%',
        slidesToShow: 1,
        arrows: true,
        dots: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 782,
                settings: {
                    arrows: false,
                    centerMode: false,
                    centerPadding: '5%',
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '0',
                    slidesToShow: 1
                }
            }
        ]
    });
    
    $( '.summary-page-slider' ).slick({
        //centerMode: true,
        //centerPadding: '20%',
        slidesToShow: 2,
        arrows: true,
        dots: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 782,
                settings: {
                    arrows: false,
                    centerMode: false,
                    centerPadding: '0',
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '0',
                    slidesToShow: 1
                }
            }
        ]
    });
    
    $( '.recent-news-slider' ).slick({
        centerMode: true,
        centerPadding: '20%',
        slidesToShow: 1,
        arrows: false,
        dots: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 782,
                settings: {
                    arrows: false,
                    centerMode: false,
                    centerPadding: '10%',
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '0',
                    slidesToShow: 1
                }
            }
        ]
    });
    
    
    $( '.recent-insights-slider' ).slick({
        centerMode: true,
        centerPadding: '15%',
        slidesToShow: 1,
        arrows: true,
        dots: true,
        infinite: true,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 782,
                settings: {
                    arrows: false,
                    centerMode: false,
                    centerPadding: '10%',
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '0',
                    slidesToShow: 1
                }
            }
        ]
    });
    
    
    
    /*
     * Copy Article URL
     */
    $( 'body' ).on( 'click', '.share-article .link', function( event ) {
        navigator.clipboard
          .writeText( $( '.share-article .link' ).attr( 'href' ) )
          .then(
              success => showCopyConfirmed(), 
              err => console.log( 'error copying link' )
          );
        event.preventDefault();
    });
    function hideCopyConfirmed() {
        $( '.share-article .copied' ).remove();
    }
    function showCopyConfirmed() {
        $( '.share-article .link'  ).after( '<span class="copied">Link copied!</span>' );
        setTimeout( hideCopyConfirmed, 3000 );
    }
    

    
    
    /*
	 * Legal Disclaimer Modal
	 */
    
    function getCookie(name) {
        var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
    }
    function setCookie(name, value, days) {
        var d = new Date;
        d.setTime(d.getTime() + 24*60*60*1000*days);
        document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
        //console.log( 24*60*60*1000*days );
        //console.log( d );
        //console.log( d.toGMTString() );
        //console.log( name + "=" + value + ";path=/;expires=" + d.toGMTString() );
    }
    function deleteCookie(name) { setCookie(name, '', -1); }
    
    
    $( 'body' ).on( 'click', '.legal-disclaimer-button', function( event ) {
        // TEMPORARY BUTTON FOR TESTING PURPOSES
        $( '#legal-disclaimer-popup' ).foundation( 'open' );
    });
    
    // Check if Popup notification should be shown,
    // check if the popup exists on the page,
    // if so then check if the cookie exists,
    // if so then don't show, if not then show popup
    if ( $( '#legal-disclaimer-popup' ).length > 0 ) {
        var cookiereference = '';
        if ( $( '#brightwell_popup_notice_link_cookie' ).length > 0 ) {
            cookiereference = $( '#brightwell_popup_notice_link_cookie' ).val();
        }
        var popupcookie = getCookie( 'brightwell-legal-popup-notification' + cookiereference );
        //console.log( 'popupcookie: ' + popupcookie );
        if ( popupcookie === null ) {
            //console.log( 'Cookie "brightwell-legal-popup-notification' + cookiereference + ' could not be found');
            $( '#legal-disclaimer-popup' ).foundation( 'open' );
        }
    }
        
    $( 'body' ).on( 'click', '#legal-disclaimer-popup .accept', function( event ) {
        var cookiereference = '';
        var cookieduration = 365;
        if ( $( '#brightwell_popup_notice_link_cookie' ).length > 0 ) {
            cookiereference = $( '#brightwell_popup_notice_link_cookie' ).val();
        }
        if ( $( '#brightwell_popup_notice_link_cookie_duration' ).length > 0 && $( '#brightwell_popup_notice_link_cookie_duration' ).val() != '' ) {
            cookieduration = $( '#brightwell_popup_notice_link_cookie_duration' ).val();
        }
        //console.log( 'cookieduration: ' + cookieduration );
        //console.log( 'cookie name: ' + 'brightwell-legal-popup-notification' + cookiereference );
        setCookie( 'brightwell-legal-popup-notification' + cookiereference, 'confirm-legal-disclaimer-viewed', cookieduration );
        $( '#legal-disclaimer-popup' ).foundation( 'close' );
        event.preventDefault();
    });
    
    
    /*
	 * Team Members Modals
	 */
    var team_member_link_arr = [];
    var team_member_current = -1;
    
    function getPositionInTeamMemberLinkArr() {
        // Check where we are in the `team_member_link_arr` array,
        // If we are at the start of the array then disable the `previous` button.
        // If we are at the end of the array then disable the `next` button.
        
        var index = team_member_current;
        
        if ( index <= 0 ) { // If at start of array then we can't go lower
            // Disable `previous` button
            $( '#team_member_next_prev_nav .previous' ).attr( 'disabled', 'disabled' );
            
            // Enable `next` button
            $( '#team_member_next_prev_nav .next' ).removeAttr( 'disabled' );
            
            //console.log( 'We are at the start of the array' );
            
        } else if ( index == ( team_member_link_arr.length - 1 ) ) { // If at end of array then we can't go higher
            // Enable `previous` button
            $( '#team_member_next_prev_nav .previous' ).removeAttr( 'disabled' );
            
            // Disable `next` button
            $( '#team_member_next_prev_nav .next' ).attr( 'disabled', 'disabled' );
            
            //console.log( 'We are at the end of the array' );
            
        } else {
            // Enable `previous` button
            $( '#team_member_next_prev_nav .previous' ).removeAttr( 'disabled' );
            
            // Enable `next` button
            $( '#team_member_next_prev_nav .next' ).removeAttr( 'disabled' );
            
            //console.log( 'We are somewhere in the middle of the array' );
            
        }
    }
    
    function loadTeamMemberDetails( mode ) {        
        if ( mode == 'previous' ) {
            team_member_current--;
        } else if ( mode == 'next') {
            team_member_current++;
        }
        var $modal = $( '#team-detail-popup' ); // Specify the modal's ID
        var $url = team_member_link_arr[team_member_current];
        $.ajax( $url )
			.done(function( resp ) {
			$modal.html( resp ).foundation( 'open' );
		});
    }
    
	$( 'body' ).on( 'click', '.team-members a.team-inner', function( event ) {
		var $modal = $( '#team-detail-popup' ); // Specify the modal's ID
		var $url = $( this ).attr( 'href' ); // Get the url from the href attribute and load this in as HTML into the modal
        // We need to get a list of the Team members for the Next / Previous functionality in the modal...
        // First we clear the array use to store the list...
        team_member_link_arr = [];
        
        // Get parent `.team-members` element to loop over and get the links...
        var team_members = $( this ).parents( '.team-members' );
        team_members.find( '.column' ).each(function( index ) {
            var team_member = $( this ).find( 'a' ).attr( 'href' );
            team_member_link_arr.push( team_member );
        });
        //console.table( team_member_link_arr );
        
        // See what index this clicked link is in the `team_member_link_arr`
        // and set the `team_member_current` variable...
        team_member_current = team_member_link_arr.indexOf( $( this ).attr( 'href' ) );
        //console.log( 'OPENING MODAL: team_member_current: ' + team_member_current );
        
		$.ajax( $url )
			.done(function( resp ) {
			$modal.html( resp ).foundation( 'open' );
		});
		
        event.preventDefault();
        
	});
    
    $( '#team-detail-popup' ).on( 'open.zf.reveal', function() {
        // Once the Team members modal opens we check the position and enable / disable `Next` and `Previous` buttons
        getPositionInTeamMemberLinkArr();
    });
    
    $( 'body' ).on( 'click', '#team_member_next_prev_nav .previous', function( event ) {
        loadTeamMemberDetails( 'previous' ); // Load previous Team Member
        event.preventDefault();
    });
    
    $( 'body' ).on( 'click', '#team_member_next_prev_nav .next', function( event ) {
        loadTeamMemberDetails( 'next' ); // Load next Team Member
        event.preventDefault();
    });
    
    
    
    
    
    /*
	 * Main Menu
	 */
	$( 'body' ).on( 'click', '.main_navigation .menu-icon', function( event ) {
		if ( $( '#main-menu-mobile' ).is( ':visible' ) ) {
			$( this ).addClass( 'active' );
		} else {
			$( this ).removeClass( 'active' );
		}
		$( '.search-menu-panel' ).addClass( 'hide' );
		event.preventDefault();
	});
    
    $( 'body' ).on( 'click', '.search', function( event ) {
		//console.log( 'Search' );
        // hideMenus();
        // hideSubMenus();
        if ( Foundation.MediaQuery.atLeast( 'large' ) ) {
            var $element = $( 'header' );
            var h = $element.outerHeight();
            console.log( h );
            $( '.search-menu-panel' ).css( 'top', h + 'px' );
        } else {
			$( '.search-menu-panel' ).addClass( 'hide' );
            $( '.header-wrapper' ).removeClass( 'active' );
		}
        
		$( '.sub-menu .sub-menu' ).addClass( 'hide' );
		$( '.main_nav_menu li' ).removeClass( 'sub-menu-active' );
		$( '#main-menu-mobile' ).hide();
		$( '.menu-icon' ).removeClass( 'active' );
        
		if ( $( '.search-menu-panel' ).hasClass( 'hide' ) ) {
            $( '.header-wrapper' ).addClass( 'active' );
			$( '.search-menu-panel' ).removeClass( 'hide' );
			$( '#s' ).focus();
		} else {
			$( '.search-menu-panel' ).addClass( 'hide' );
            $( '.header-wrapper' ).removeClass( 'active' );
		}
        
		event.preventDefault();
	});
	
	//$( 'body' ).on( 'mouseenter', '.main_nav_menu li.menu-item-has-children > a', function( event ) {
	$( 'body' ).on( 'mouseenter', '.main_nav_menu li > a', function( event ) {
		//console.log( 'Main menu' );
		if ( Foundation.MediaQuery.atLeast( 'large' ) ) {
            
            //if ( $( this ).parent().hasClass( 'sub-menu-active' ) ) {
            if ( $( this ).parent().hasClass( 'menu-item-has-children' ) ) {
                // hideMenus();
                // hideSubMenus();
                var $element = $( 'header' );
                var h = $element.outerHeight();
                console.log( h );

                // Open Sub panel and display Sub menu
                var id = $( this ).parent().attr( 'id' );
                console.log( 'id: ' + id );
                console.log( '#subpanel-' + id );
                
                $( '.sub-menu-panel' ).css( 'top', h + 'px' );
                $( '.sub-menu-panel' ).removeClass( 'hide' );
                
                $( '.subpanel-container' ).addClass( 'hide' );
                $( '#subpanel-' + id ).removeClass( 'hide' );
                
                $( '.header-wrapper' ).addClass( 'active' );
                $( this ).parent().addClass( 'sub-menu-active' );
                $( '#subpanel-' + id + ' li:first-child a' ).focus();
            } else {
                // hideMenus();
                // hideSubMenus();
                
            }
            
		} else {
            // hideMenus();
            // hideSubMenus();
		}
	});
	
	$( 'body' ).on( 'mouseenter', '.sub-menu-panel .sub-menu li.menu-item-has-children > a', function( event ) {
		//console.log( 'Entering Sub menu' );
        // hideSubMenus();
        $( this ).siblings( '.sub-menu' ).removeClass( 'hide' );
        $( this ).parent().addClass( 'sub-menu-active' );
        $( this ).parent().parent().addClass( 'has-sub-menu-active' );
		
		if ( $( this ).parent().hasClass( 'menu-item-has-children' ) ) {
			event.preventDefault();
		}
	});
    
    $( 'body' ).on( 'mouseleave', '.sub-menu-panel', function( event ) {
        //console.log( 'Leaving Sub menu Panel' );
        // hideMenus();
        // hideSubMenus();
    });
	
    $( 'body' ).on( 'mouseleave', '.sub-menu .sub-menu', function( event ) {
        //console.log( 'Leaving Sub Sub menu' );
        hideSubMenus();
    });
	
	function hideMenus() {
		$( '.search-menu-panel' ).addClass( 'hide' );
		// $( '.sub-menu-panel' ).addClass( 'hide' );
		$( '.main_nav_menu li' ).removeClass( 'sub-menu-active' );
		$( '.header-wrapper' ).removeClass( 'active' );
	}
	
	function hideSubMenus() {
        $( '.sub-menu' ).removeClass( 'has-sub-menu-active' );
        $( '.sub-menu li' ).removeClass( 'sub-menu-active' );
        $( '.sub-menu .sub-menu' ).addClass( 'hide' );
	}
	
	hideMenus();
	hideSubMenus();
	
	$( window ).on( 'changed.zf.mediaquery', function( event, newSize, oldSize ) {
		if ( newSize == 'small' || newSize == 'medium'  ) {
			hideMenus();
            hideSubMenus();
		}
	});
    
    /*
	 * Mobile Menu
	 */
    $( '[data-responsive-toggle="main-menu-mobile"]' ).on( 'toggled.zf.responsiveToggle', function( event ) {
        if ( $( 'button.menu-icon' ).hasClass( 'active' ) ) {
            $( 'button.menu-icon span' ).text( 'Open menu' );
        } else {
            $( 'button.menu-icon span' ).text( 'Close menu' );
        }
		event.preventDefault();
	});
        
    $( '.reveal.mobile-menu' ).on( 'open.zf.reveal', function() {
		console.log( 'Mobile menu opened' );
        // Focus on main heading, we give a slight delay to allow the reveal to show:
        setTimeout(() => {
            $( '#mobile_navigation_menu_heading' ).focus();
            Foundation.reInit('Drilldown');
            //$('#mobilemenu_trigger').foundation();
        }, '500');
        
        //var moptions = {dataAutoHeight: true, dataAnimateHeight: true, dataScrollTop: true, dataParentLink: true};
        //var elem = new Foundation.Drilldown($('#mobilemenu_trigger'), moptions);
            
        //var targ = $('#mobilemenu_trigger');
        //var mmenu = new Foundation.Drilldown(targ);
        
        
        
        //$( '#mobilemenu_trigger' ).foundation('_prepareMenu');
        
	});
							
	$( '.reveal.mobile-menu' ).on( 'closed.zf.reveal', function() {
		//console.log( 'Mobile menu closed' );
	});


    // news item to be moved under menu
    const subMenuPanel = $('.sub-menu-panel')[0];
    const subMenuContainer = $('.menu-item-has-children')[0];
    $(subMenuContainer).append(subMenuPanel);


    // hack for UL children to bring different background
    const sndLvlMenuItmsWithChildren = $('.menu li li.menu-item-has-children');
    sndLvlMenuItmsWithChildren
        .mouseover (function(e) {
            $(this).parent('ul').addClass('hover-active');
        })
        .mouseout (function(e) {
            $(this).parent('ul').removeClass('hover-active');
        })


    $( 'body' ).on( 'click', '#legal-disclaimer-popup .reject', function( event ) {
        location.href = '/contact-us/terms-conditions/';
    });

});
